// Zugriff auf die Seitenleiste von überall.
//
// Die drei Striche stehen in JEDEM Modul oben links — nicht nur auf dem
// Startbildschirm. Ohne das müsste man erst zurück zum Kachelfeld, um von der
// Tour in die Kasse zu kommen. Der Zustand lebt in der Shell (eine Leiste, ein
// Zustand); die Kopfzeilen greifen ihn hier ab.

import { createContext, useContext } from "react";

export const SidebarContext = createContext<{ oeffnen: () => void }>({
  oeffnen: () => {},
});

export const useSidebar = () => useContext(SidebarContext);
